import { useFormState } from 'react-final-form';

import {
  Icons,
  Tooltip,
  Typography,
  Box,
  Stack,
  tokens,
} from '@cast/design-system';

import { settingsRowDescriptions } from './settingsRowDescriptions';
import { settingsRowError } from './settingsRowError';
import { SettingRow } from '../../../../../../_woop-settings/_components/layout/SettingRow';
import { vpaSettingsConstants } from '../../../../../../_woop-settings/_constants/settingsConstants';
import { useVpaSelectedSettingName } from '../../../../../../_woop-settings/vpaSelectedSettingNameContexts';
import { WorkloadDetailsFormModel } from '../../../../_types';
import { RightsizingSettingsV1ValidationSchema } from '../../../../_validations/rightsizing-settings-v1-validation.schema';
import { WorkloadVpaFormSettings } from '../../_constants';

type WorkloadSettingRowProps = {
  name: WorkloadVpaFormSettings;
};

export const VpaSettingRow = ({ name }: WorkloadSettingRowProps) => {
  const { values, errors } = useFormState<WorkloadDetailsFormModel>({
    subscription: { values: true, errors: true },
  });

  const { settingName, setSettingName, useSettingIsDefault } =
    useVpaSelectedSettingName();

  const isSettingDefault = useSettingIsDefault(name);

  const isSelected = settingName === name;

  const descriptions = settingsRowDescriptions[name]({
    formModel: values,
  });

  const error = settingsRowError[name]({
    errors: errors as RightsizingSettingsV1ValidationSchema,
  });

  const { title } = vpaSettingsConstants[name];

  return (
    <SettingRow
      title={title}
      description={descriptions.join(', ')}
      isDefault={Boolean(isSettingDefault)}
      isSelected={isSelected}
      hasError={!!error}
      onClick={() => setSettingName(name)}
      testId={`setting-row-${name}`}
      startAdornment={
        !isSettingDefault ? (
          <Tooltip
            title={
              <Stack direction="row" gap={4}>
                <Typography variant="P12R">{title}:</Typography>
                <Typography variant="P12B">Overrides Policy</Typography>
              </Stack>
            }
            sx={{ maxWidth: 500 }}
          >
            <Box
              justifyContent="center"
              alignItems="center"
              display="inline-flex"
              bgcolor={tokens.theme.bg.structural.surfaceRaised}
              color={tokens.theme.fg.structural.primary}
              borderRadius="12px"
              fontSize={12}
              p={1}
              width={12}
            >
              <Icons.CastHorizontalLinkDash size={11} />
            </Box>
          </Tooltip>
        ) : (
          <Box width={12} />
        )
      }
    />
  );
};
